<template>
  <custom-dialog class="delivery-item-dialog" :title="$t('crm_delivery_dialog.xin_zeng_chu_ku_dan')" :visible="visible" v-on="$listeners" :appendToBody="true" width="78%">
    <div class="dialog-body">
      <div class="item-title">
        {{ $t('crm_delivery_dialog.xzsdpj') }}
        <div class="delivery-tip">
          <span>{{ $t('crm_delivery_dialog.zzndkbjqzshgszdpjcl') }}</span>
          {{ $t('crm_delivery_dialog.yzssl') }}
          <strong style="color: #00afff">{{ total }}</strong>
        </div>
      </div>
      <custom-table index :data="tableList" tableCode="delivery_device" :slots="['useStockNum']" height="400px">
        <template slot="useStockNum" slot-scope="scope">
          <el-input
            :min="0"
            :max="scope.row.stockNum"
            type="number"
            v-input.intp="[0, scope.row.stockNum]"
            style="width: 80px"
            :disabled="scope.row.stockNum <= 0"
            v-model="scope.row.useStockNum"
            @change="cacheDetail(scope.row)"
          ></el-input>
        </template>
      </custom-table>
      <div class="table-page">
        <custom-page :total="totalRows" :page="pageNum" :size="pageSize" @change="onPageChange"></custom-page>
      </div>
      <div class="item-title" style="margin-top: 16px">{{ $t('crm_delivery_dialog.shshxx') }}</div>
      <div class="address-box" style="width: 100%">
        <div class="address-btn" v-if="!form.consigneeName" @click="changeAddress()">+</div>
        <div class="address-item" v-else>
          <h3>{{ $t('crm_delivery_dialog.shou_hou_gong_si') }}{{ afterServiceName }}</h3>
          <h3>{{ $t('crm_delivery_dialog.shou_huo_ren') }}{{ form.consigneeName }}</h3>
          <h3>{{ $t('crm_delivery_dialog.dian_hua') }}{{ form.consigneePhone }}</h3>
          <h3>{{ $t('crm_delivery_dialog.shou_huo_di_zhi') }}{{ form.consigneeAddress }}</h3>
          <span class="address-modify-btn" @click="changeAddress()">{{ $t('Common.com_modify') }}</span>
        </div>
      </div>
      <div class="item-title" style="margin-top: 16px">{{ $t('crm_delivery_dialog.wu_liu_xin_xi') }}</div>
      <el-form ref="form" :model="form" label-position="top">
        <el-row :gutter="20">
          <el-col :span="8" :offset="0">
            <el-form-item :label="$t('crm_delivery_dialog.wu_liu_gong_si')">
              <custom-select
                :model="form"
                :props="{ label: 'name', value: 'name', map: { value: 'logisticsCompanyCode' } }"
                filterable
                v-model="form.logisticsCompany"
                code="ice_logistics_company"
                :placeholder="$t('Common.com_please_select')"
                width="100%"
              ></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="0" v-if="!form.logisticsCompanyCode">
            <el-form-item :label="$t('crm_delivery_dialog.qi_ta_wu_liu')">
              <el-input v-model="form.customLogisticsCompany"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="0">
            <el-form-item :label="$t('crm_delivery_dialog.wu_liu_dan_hao')">
              <el-input v-model="form.shipmentNum"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="item-title" style="margin-top: 16px">{{ $t('crm_delivery_dialog.xin_xi_hui_zong') }}</div>
      <div class="info-summary">
        <h1>
          {{ $t('crm_delivery_dialog.yzssl') }}
          <span style="color: #00afff">{{ total }}</span>
        </h1>
        <h1>
          {{ $t('crm_delivery_dialog.sycldksl') }}
          <span style="color: #00afff">{{ useStockTotal }}</span>
        </h1>
        <div class="info" v-if="useStockList.length">
          <div :key="item" v-for="item in useStockList">{{ item }}</div>
        </div>
        <h1>
          {{ $t('crm_delivery_dialog.bcckxfsl') }}
          <span style="color: #00afff">{{ total - useStockTotal }}</span>
        </h1>
        <div class="info" v-if="useList.length">
          <div :key="item" v-for="item in useList">{{ item }}</div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" :disabled="disableSubmit" @click="saveShip">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <!-- 选择地址 -->
    <contractManagement-chooseAddress-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="addAddress"></contractManagement-chooseAddress-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import contractManagementChooseAddressDialog from '@/pages/crm/components/chooseAddressDialog.vue';

export default {
  mixins: [dialogMixins],
  components: { contractManagementChooseAddressDialog },
  data() {
    return {
      tableList: [],
      afterServiceName: '',
      pageNum: 1,
      pageSize: 50,
      totalRows: 0,
      // 翻页时缓存已编辑的抵扣数量
      detailMap: {},
      // 本次发货的订单商品编码列表（全选时来自 orderGoodsCodes 接口，非全选时来自选中行）
      orderGoodsCodeList: [],
      form: {
        consigneeAddress: '', // 收货地址
        consigneeName: '', // 收货人
        consigneePhone: '', // 收货人电话
        logisticsCompany: '', // 物流公司
        customLogisticsCompany: '',
        logisticsCompanyCode: '', // 物流编码
        shipmentNum: '', // 物流单号
      },
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      deviceIndex: undefined,
      disableSubmit: false,
    };
  },
  mounted() {
    this.getTableList();
  },
  computed: {
    // 是否勾选了全部查询结果
    isSelectAll() {
      return !!this.model.isSelectAll;
    },
    // 列表页带过来的全部查询参数
    searchParams() {
      return this.model.searchParams || {};
    },
    // 当前页和已翻页缓存合并后的明细
    mergedDetailList() {
      const map = { ...this.detailMap };
      this.tableList.forEach((item) => {
        map[item.orderGoodsPartId] = item;
      });
      return Object.keys(map).map((key) => map[key]);
    },
    total() {
      if (this.isSelectAll) {
        return this.model.totalPartNum || 0;
      }
      return this.tableList.reduce((pre, item) => pre + (item.bookingNum || 0), 0);
    },
    useList() {
      return this.mergedDetailList
        .filter((t) => t.bookingNum - (t.useStockNum || 0) > 0)
        .map((f) => `${f.bodyNum} ${f.codeName} *${f.bookingNum - (f.useStockNum || 0)}`);
    },
    useStockTotal() {
      return this.mergedDetailList.reduce((pre, item) => pre + (+item.useStockNum || 0), 0);
    },
    useStockList() {
      return this.mergedDetailList.filter((t) => t.useStockNum).map((f) => `${f.bodyNum} ${f.codeName} *${f.useStockNum}`);
    },
    afterServiceRow() {
      return (this.model.data && this.model.data[0]) || this.tableList[0] || {};
    },
  },
  methods: {
    getTableList: function () {
      // 获取本次发货的订单商品编码列表
      // 全选时调用 orderGoodsCodes 接口（参数与列表查询一致），非全选时合并选中行的 orderGoodsCode
      const getOrderGoodsCodeList = () => {
        if (this.isSelectAll) {
          return this.$getJSON(apis.giveawayOrderGoodsCodes, this.searchParams).then((res) => {
            const data = res.data || [];
            // 兼容返回字符串数组或对象数组
            return data.map((item) => (typeof item === 'object' ? item.orderGoodsCode : item)).filter(Boolean);
          });
        }
        return Promise.resolve((this.model.data || []).map((item) => item.orderGoodsCode));
      };
      getOrderGoodsCodeList().then((orderGoodsCodeList) => {
        // 保存编码列表，提交发货时原样携带
        this.orderGoodsCodeList = orderGoodsCodeList;
        // 通过明细分页接口加载明细，orderGoodsCodeList 作为查询条件
        this.$getJSON(apis.giveawayPreShipDetailPage, {
          orderGoodsCodeList,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }).then((res) => {
          const list = (res.data && res.data.list) || [];
          list.forEach((item) => {
            const cached = this.detailMap[item.orderGoodsPartId];
            item.useStockNum = cached ? cached.useStockNum : '';
          });
          this.tableList = list;
          this.totalRows = (res.data && res.data.total) || 0;
        });
      });
    },
    // 缓存当前行抵扣数量，翻页后回填
    cacheDetail(row) {
      this.$set(this.detailMap, row.orderGoodsPartId, { ...row });
    },
    onPageChange({ page, size }) {
      this.tableList.forEach((item) => {
        this.cacheDetail(item);
      });
      this.pageNum = page;
      this.pageSize = size || this.pageSize;
      this.getTableList();
    },
    // 修改地址
    changeAddress: function () {
      this.dialogVisible = true;
      this.dialogModel.title = this.$t('crm_delivery_dialog.xuan_ze_shou_huo_ren');
      this.dialogModel.data = {
        partnerOrgId: this.afterServiceRow.afterServiceId,
        type: 'service',
      };
    },
    // 添加地址
    addAddress: function (arg) {
      const item = arg[0];
      this.afterServiceName = this.afterServiceRow.afterServiceName;
      this.form.consigneeName = item.consigneeName; // 收货人
      this.form.consigneePhone = item.consigneePhone; // 收货人电话
      this.form.consigneeAddress = `${item.country}${item.province}${item.city}${item.detailAddress}`; // 详细地址
    },
    // 保存新增编辑
    saveShip: function () {
      if (!this.form.consigneePhone) {
        this.$message.error(this.$t('crm_delivery_dialog.qtxshshxx'));
        return;
      }
      this.tableList.forEach((item) => {
        this.cacheDetail(item);
      });
      // 仅提交 useStockNum 发生改变（填了抵扣数量）的明细
      const detailList = this.mergedDetailList
        .filter((t) => (t.useStockNum || 0) > 0)
        .map((t) => ({
          bookingNum: t.bookingNum,
          orderGoodsCode: t.orderGoodsCode,
          orderGoodsPartId: t.orderGoodsPartId,
          useStockNum: t.useStockNum || 0,
        }));
      const logisticsCompany = this.form.logisticsCompanyCode ? this.form.logisticsCompany : this.form.customLogisticsCompany;
      const payload = {
        ...this.form,
        detailList,
        logisticsCompany,
        // orderGoodsCodeList 原封不动提交
        orderGoodsCodeList: this.orderGoodsCodeList,
      };
      this.disableSubmit = true;
      this.$postJSON(apis.giveawayShip, payload).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
        this.disableSubmit = false;
      }).catch(() => {
        this.disableSubmit = false;
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.delivery-item-dialog {
  .delivery-tip {
    float: right;
    font-size: 14px;
    span {
      margin-right: 12px;
      font-size: 13px;
      font-weight: normal;
      color: #909090;
    }
  }
  .info-summary {
    h1 {
      font-weight: bold;
      font-size: 12px;
      line-height: 28px;
    }
    .info {
      padding: 16px 24px;
      margin: 8px 0;
      background-color: #eeeeee;
      max-height: 240px;
      overflow-y: auto;
    }
  }

  // 地址
  .address-box {
    > h3 {
      color: #000;
      padding-bottom: 16px;
      line-height: 24px;
    }
    .address-btn {
      border: 2px dashed #00afff;
      position: relative;
      height: 80px;
      line-height: 70px;
      text-align: center;
      font-size: 40px;
      color: rgba(0, 0, 0, 0.45);
    }
    .address-item {
      border: 2px dashed #00afff;
      position: relative;
      min-height: 80px;
      padding: 12px 16px;
      h3 {
        line-height: 24px;
        height: 24px;
        font-size: 12px;
        color: #1e1e1e;
        font-weight: bold;
        border: none;
      }
      p {
        font-size: 12px;
        line-height: 24px;
        color: #666;
        margin-top: 8px;
        height: 24px;
      }
      .address-modify-btn {
        position: absolute;
        right: 16px;
        bottom: 10px;
        font-size: 12px;
        line-height: 24px;
        color: #f33a73;
        cursor: pointer;
      }
      .address-default {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 12px;
        color: #fff;
        padding: 0 13px;
        background: rgba(0, 0, 0, 0.19);
        border-radius: 0px 0px 0px 100px;
      }
    }
  }

  .el-form-item {
    width: 100%;
  }

  .el-input-number--small {
    line-height: 30px;
  }

  .mce-edit-area {
    border-top: 0;
  }

  .mce-first {
    display: none;
  }
  .body-num-clear {
    cursor: pointer;
    color: $theme-color-main;
  }

  .table-page {
    margin-top: 8px;
    text-align: right;
  }
}
</style>
